<template>
  <div>
    <v-alert
      :value="errorExists"
      type="error"
      transition="slide-y-reverse-transition"
      @click="removeErrors"
      class="errorMessage"
    >
      {{ "ERROR: " + this.errorType + " " + this.errorMessage }}
    </v-alert>
  </div>
</template>

<script>
import { toastBus } from './toast/toast'
export default {
  computed: {
    errorExists: function () {
      let value = this.$store.state.auth.errorMessage
      if (value !== undefined && value !== null) {
        toastBus.$emit('show-toast', {
          message: 'Something bad happened. Please try again or contact Dev Team.',
          type: 'error',
          duration: 3000 // to remove the error automatically after 3 seconds
        })
      }
      return false
    }
  },

  /*
   * =========== only changed here ==========
   *  when mounted, the component fires removeError() after 5000 ms.
   */
  mounted () {
    setTimeout(this.removeErrors, 5000)
  },
  methods: {
    removeErrors () {
      this.$store.state.auth.errorMessage = null
      this.$store.state.auth.errorType = null
    }
  },

  data () {
    return {
    }
  }
}
</script>

<style lang="less">
  .errorMessage {
    position: fixed;
    width: 100%;
    z-index: 999999999;
  }
</style>
